















import Vue from 'vue'
import Component from 'vue-class-component'
import { Injector } from '@/config/dependency-injection'
import RespondecoForm from '@/shared/components/respondeco-form.vue'
import VueMultiselect from 'vue-multiselect'
import RespondecoOrganisationSelect from '@/shared/components/respondeco-organisation-select.vue'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import { DialogService } from '@/shared/dialog/dialog-service'
import RespondecoDialog from '@/main/dialog.vue'
import RespondecoDialogButtons from '@/main/dialog-buttons.vue'
import RespondecoDialogButton from '@/main/dialog-button.vue'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {
    RespondecoDialogButton,
    RespondecoDialogButtons,
    RespondecoDialog,
    RespondecoOrganisationSelect,
    VueMultiselect,
    RespondecoForm,
  },
  data() {
    return {
      organisation: undefined,
    }
  },
})
export default class AddOrganisationDialog extends Vue {
  public static readonly dialogName: string = 'ADD_ORGANISATION_DIALOG'

  @Prop({
    default: false,
    type: Boolean,
  })
  public readonly excludeSelf!: boolean

  @Prop({
    default: () => [],
    type: Array,
  })
  public readonly partners!: OrganisationLite[]

  @Prop({
    default: null,
    type: String,
  })
  public readonly project!: string | null

  public organisation?: OrganisationLite

  private dialogService = Injector.get(DialogService)

  public submit() {
    this.$emit('input', this.organisation)
    this.dialogService.hide(AddOrganisationDialog.dialogName)
  }
}
